import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    let section = this.element.closest(".member-contact");
    this.memberInput = section.querySelector('input[name="member_id"]');

    this.element.querySelectorAll("input[type='radio']").forEach((radio) => {
      radio.addEventListener("change", (evt) => {
        this.memberInput.value = evt.target.value;
      });
    });
  }
}
